'use client';

import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';

import RenewalButton from '@/components/features/common/renewal/renewal-button';
import { SHOW_SWITCH_VERSION_PATHS } from '@/constants';
import { useLanguage } from '@/hooks/use-language';
import Logo from 'public/images/common/logo.svg';

import SubscribeButton from '../subscribe-button';

import LanguageSelector from './language-selector';
import Logout from './logout';
import NavigationLinks from './navigation-links';
import SwitchVersionButton from './switch-version-button';

export default function Nav({
  dictionary,
  isErrorPage = false,
}: {
  dictionary: Record<string, string>;
  isErrorPage?: boolean;
}) {
  const { currentLanguage } = useLanguage();
  const pathname = usePathname().replace('/zh', '');
  const searchParams = useSearchParams();
  const noMenu = searchParams.get('noMenu');

  return (
    <nav className="relative bg-white">
      <div className="relative flex h-[68px] w-full items-center px-[64px] text-text-primary">
        {/* Logo */}
        <Link href={`/${currentLanguage}/home`}>
          <Logo />
        </Link>
        {!noMenu ? (
          <>
            {/* Navigation Links */}
            <NavigationLinks
              dictionary={dictionary}
              isErrorPage={isErrorPage}
            />

            {/* Right side items */}
            <div className="ml-auto flex h-full items-center space-x-6">
              {!isErrorPage && <SubscribeButton />}
              {!isErrorPage && <RenewalButton />}
              <LanguageSelector />
              {!isErrorPage && SHOW_SWITCH_VERSION_PATHS.includes(pathname) && (
                <SwitchVersionButton />
              )}
              <Logout dictionary={dictionary} isErrorPage={isErrorPage} />
            </div>
          </>
        ) : (
          <div className="ml-auto flex h-full items-center space-x-6">
            <LanguageSelector />
          </div>
        )}
      </div>
    </nav>
  );
}
